if (!customElements.get('v5-header-search')) {
  const template = document.createElement("template");
  template.innerHTML = `
    <style>
      .visually-hidden {display: none;}

      /*scrollbar */
      ::-webkit-scrollbar {
        height: 8px;
        width: 7px;
      }
      ::-webkit-scrollbar-track {
        background-color: rgba(0, 0, 0, 5%);
      }
      ::-webkit-scrollbar-thumb {
        background-color: rgba(144, 147, 153, 30%);
        border-radius: 2px;
        box-shadow: inset 0 0 6px rgba(0, 0, 0, 20%);
      }
      ::-webkit-scrollbar-thumb:hover {
        background-color: #b6b7b9;
      }

      .header-search__loading-state {
        display:none;
      }
      .v5-pii-warning {
        font-size: 0.875rem;
        line-height: 1.25rem;
        color: #f72626;
      }
      .field-wrap {
        display: flex;
        align-items: center;
        justify-content: space-between;
        column-gap: 1rem;
      }
      .field-wrap .field-back {
        appearance: none;
        background: transparent;
        border: none;
        padding: 0;
        display: none;
      }
      input::-webkit-clear-button,
      input::-moz-clear {
        display: none;
      }
      input::-webkit-search-cancel-button,
      input::-webkit-search-decoration,
      input::-moz-search-clear-button {
        display: none;
      }
      .header-search {
        display: none;
        width: 79rem;
        max-width: 100%;
        background-color: #FFF;
        border-radius: 0;
        overflow: hidden;
      }
      .header-search .hidden{
        display: none;
      }
      .recommend-search-list{
        display: none;
        width: 79rem;
        max-width: 100%;
        background-color: #FFF;
        border-radius: 0;
        max-height: 60vh;
        overflow-y: auto;
      }
      form.v5-search-modal__form .recommend-search-list .predictive-search__results-list {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        column-gap: 1.5rem;
        row-gap: 1.5rem;
      }
      .recommend-search-list .predictive-search__item {
        box-sizing: border-box;
        display: inline-block;
        padding-left: 0.5rem;
        padding-right: 0.5rem;
        height: 1.75rem;
        border: 1px solid #E8E8E5;
        font-size: 1rem;
        line-height: 1.625rem;
        color: #242F20;
        font-weight: 400;
        cursor: pointer;
        text-decoration: none;
      }
      .recommend-search-list .predictive-history-search__item {
        border-color: transparent;
      }
      .recommend-search-list .predictive-search__item:hover {
        border-color: #242F20;
      }
      .recommend-search-list .predictive-search__item-corner {
        position: absolute;
        right: 0;
        top: 0;
        transform: translate(50%, -50%);
        font-size: 0.625rem;
        padding: 0.125rem 0.125rem 0.0625rem;
        background-color: var(--jds-color-primary);
        color: #FFF;
      }
      .recommend-search-list a {
        font-size: 14px;
        color: #333;
      }

      @media screen and (max-width: 1023.98px) {
        .recommend-search-list{
          max-height: calc(90dvh - var(--jky-header-h));
        }
      }

      @media screen and (max-width: 749px) {
        .header-search--header {
          right: 0;
          left: 0;
          top: 100%;
        }
      }
      @media screen and (max-width: 989px) {
        .header-search {
          overflow-y: auto;
          -webkit-overflow-scrolling: touch;
        }
      }
      .header-search-wrapper {
        width: 100%;
        background-color: #FFF;
        position: relative;
        padding-top: 2.5rem;
      }
      .header-search-wrapper[open] .header-search,
      .header-search-wrapper[loading] .header-search {
        display: block;
      }
      .header-search-wrapper[open] .v5-search-modal__form,
      .header-search-wrapper[loading] .v5-search-modal__form {
        background: #fff;
        border-radius: 0;
        overflow: hidden;
      }

      .v5-predictive-search__heading {
        display: flex;
        color: #818181;
        font-size: 0.875rem;
        line-height: 1.25rem;
        font-weight: 400;
        margin: 2.25rem 0 1rem;
      }

      #v5-predictive-search-results {
        box-sizing: border-box;
        background-color: #FFF;
        width: 100%;
        max-width: 82.5rem;
        margin: 0 auto;
        max-height: 60vh;
        overflow-y: auto;
      }
      #v5-predictive-search-results a {
        color: #242F20;
        text-decoration: none;
        text-underline-offset: 0.25rem;
      }
      #v5-predictive-search-results a:hover {
        text-decoration: underline;
      }

      @media screen and (max-width: 1023.98px) {
        ::-webkit-scrollbar {
          height: unset;
          width: unset;
          max-width: 4px;
        }
        ::-webkit-scrollbar-track {
          background-color: unset;
        }
        ::-webkit-scrollbar-thumb {
          background-color: unset;
          border-radius: unset;
          box-shadow: unset;
        }
        ::-webkit-scrollbar-thumb:hover {
          background-color: unset;
        }
        .header-search--header {
          right: 0;
          left: 0;
          top: 100%;
        }
        .header-search {
          max-width: 100%;
        }
        .field-wrap {
          column-gap: 1rem;
        }
        .field-wrap .field-back {
          width: 1.25rem;
          height: 1.25rem;
        }

        .header-search-wrapper {
          padding-top: 1.25rem;
        }
        .v5-predictive-search__heading {
          margin: 1.75rem 0 0.875rem;
        }
        form.v5-search-modal__form .recommend-search-list .predictive-search__results-list {
          column-gap: 1rem;
          row-gap: 1rem;
        }
        .recommend-search-list .predictive-search__item {
          height: 1.625rem;
          font-size: 0.875rem;
          line-height: 1.5rem;
        }
      }

      
      .header-search-wrapper .spinner {
        width: 1.5rem;
        height: 1.5rem;
        line-height: 0;
      }

      .v5-predictive-search__heading .spinner {
        margin: 0 0.25rem;
      }

      .header-search-wrapper:not([loading]) .v5-predictive-search__heading .spinner,
      .header-search-wrapper:not([loading]) .predictive-search__loading-state,
      .header-search-wrapper:not([loading]) .predictive-search-status__loading {
        display: none;
      }
      .header-search-wrapper[loading] .predictive-search__loading-state {
        display: flex;
        justify-content: center;
        padding: 1rem;
      }
      .header-search-wrapper[loading] .v5-predictive-search__heading~.predictive-search__loading-state,
      .header-search-wrapper[loading] .predictive-search__results-list:first-child {
        display: none;
      }
      form.v5-search-modal__form .predictive-search__results-list {
        margin: 0;
        padding-left: 0;
        display: flex;
        flex-direction: column;
        row-gap: 1.5rem;
      }
      .predictive-search__list-item {
        list-style: none;
        position:relative;
      }

      .predictive-search__list-item[aria-selected="true"] .predictive-search__item-heading,
      .predictive-search__list-item:hover .predictive-search__item-heading {
        text-underline-offset: 0.25rem;
      }
      .predictive-search__item-heading {font-weight: normal;}

      .predictive-search__item--link {
        display: flex;
        align-items: center;
        column-gap: 0.5rem;
      }

      .predictive-search__item-content {
        display: flex;
        flex-direction: column;
      }
      .predictive-search__item-content--centered {
        justify-content: center;
      }

      .predictive-search__item-vendor {
        font-size: 0.875rem;
      }

      .predictive-search__item-heading {
        margin: 0;
        font-size: 0.875rem;
        line-height: 1.25rem;
        color: #242F20;
      }

      .predictive-search__item .price {
        color: #242F20;
        font-size: 1.25rem;
      }

      .predictive-search__item-vendor+.predictive-search__item-heading,
      .predictive-search .price {
        margin-top: 0.5rem;
      }
      .predictive-search__item--term {
        justify-content: space-between;
        align-items: center;
        word-break: break-word;
        line-height: 1;
        font-size: 14px;
        outline: none;
        border: none;
        cursor: pointer;
      }
      @media screen and (min-width: 750px) {
        .predictive-search__item--term {
          padding-top: 1rem;
          padding-bottom: 1rem;
        }
      }

      .predictive-search__image {
        flex-shrink: 0;
        object-fit: contain;
        width: 3.75rem;
        height: 3.75rem;
        background-color: #F5F5F5;
      }

      .v5-search-modal__form {
        width: 82.5rem;
        margin: 0 auto;
        padding-bottom: 2.5rem;
      }
      .search__input {
        padding: 0.75rem 3.25rem;
        font-size: 0.875rem;
        color: #333;
        line-height: 24px;
        width: 100%;
        border: none;
        outline: none;
      }
      .field {
        flex: 1;
        display: flex;
        height: 3rem;
        border: 1px solid #E8E8E5;
        position: relative;
        overflow: hidden;
      }
      @media screen and (max-width: 1023.98px) {
        .v5-search-modal__form {
          width: 100%;
          box-sizing: border-box;
          padding: 0 1rem 2rem;
        }
        .search__input {
          padding: 0 2.75rem;
          font-size: 1rem;
          line-height: 1.5rem;
        }
        .field {
          height: 2.5rem;
        }
        .predictive-search__item-content {
          padding-right: 38px;
        }
      }

      .search__button {
        position: absolute;
        left: 1rem;
        top: 50%;
        transform: translateY(-50%);
        background: transparent;
        outline: none;
        border: none;
        padding: 0;
        height: 1.5rem;
      }
      .search-modal__close-button {
        background: transparent;
        outline: none;
        border: none;
        padding: 0;
        padding-right: 1rem;
        height: 1.5rem;
      }
      .search__button svg, .search-modal__close-button svg {
        width: 1.5rem;
        height: 1.5rem;
        cursor: pointer;
      }
      .search-modal__close-button:hover svg path {
        fill: var(--jds-color-primary);
      }

      @media screen and (max-width: 1023.98px) {
        .search__button, .search-modal__close-button {
          height: 1rem;
          padding-right: 0;
        }
        .search__button svg, .search-modal__close-button svg {
          width: 1rem;
          height: 1rem;
        }
        .search-modal__close-button:hover svg path {
          fill: #242F20;
        }
      }
    </style>

    <form action="/search" method="get" role="search" class="search v5-search-modal__form">
      <div class="field-wrap">
        <button class="field-back" aria-label="Back">
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M8.5 10L12.5 14L11.9699 15.3027L6.66662 9.99942L11.9699 4.69617L12.5 6L8.5 10Z" fill="black" fill-opacity="0.65"/>
          </svg>
        </button>
        <div class="field">
          <input
            class="search__input
            field__input"
            id="Search-In-Modal"
            type="text" name="q" value=""
            placeholder=""
            role="combobox" aria-expanded="false"
            aria-owns="header-search-results-list" aria-controls="header-search-results-list"
            aria-haspopup="listbox" aria-autocomplete="list" autocorrect="off" autocomplete="off" autocapitalize="off"
            spellcheck="false" aria-activedescendant=""
          >
          <input type="hidden" name="options[prefix]" value="last">
          <input type="hidden" name="type" value="product">
          <button class="search__button field__button" aria-label="Search">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M21.0002 21L16.6572 16.657M16.6572 16.657C17.4001 15.9141 17.9894 15.0321 18.3914 14.0615C18.7935 13.0909 19.0004 12.0506 19.0004 11C19.0004 9.94936 18.7935 8.90905 18.3914 7.93842C17.9894 6.96779 17.4001 6.08585 16.6572 5.34296C15.9143 4.60007 15.0324 4.01078 14.0618 3.60874C13.0911 3.20669 12.0508 2.99976 11.0002 2.99976C9.9496 2.99976 8.90929 3.20669 7.93866 3.60874C6.96803 4.01078 6.08609 4.60007 5.34321 5.34296C3.84288 6.84329 3 8.87818 3 11C3 13.1217 3.84288 15.1566 5.34321 16.657C6.84354 18.1573 8.87842 19.0002 11.0002 19.0002C13.122 19.0002 15.1569 18.1573 16.6572 16.657Z" stroke="#C6C7C8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <button
          type="button"
          class="search-modal__close-button modal__close-button link link--text focus-inset"
          aria-label="Close"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M6.39945 18.6552L5.3457 17.6014L10.9457 12.0014L5.3457 6.40141L6.39945 5.34766L11.9995 10.9477L17.5995 5.34766L18.6532 6.40141L13.0532 12.0014L18.6532 17.6014L17.5995 18.6552L11.9995 13.0552L6.39945 18.6552Z" fill="#1F1F1F"/>
          </svg>
        </button>
      </div>
      <div class="v5-pii-warning" role="alert"></div>
      <div class="recommend-search-list"></div>
      <div class="header-search header-search--header" tabindex="-1" data-header-search>
        <div class="header-search__loading-state">
          <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
            <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
          </svg>
        </div>
      </div>
      <span class="header-search-status visually-hidden" role="status" aria-hidden="true"></span>
    </form>
  `

  class V5HeaderSearch extends HTMLElement {
    constructor() {
      super();

      this.innerDOM = document.createElement("div")
      this.innerDOM.classList.add("header-search-wrapper")
      if (this.getAttribute("data-class")) {
        this.innerDOM.classList.add(this.getAttribute("data-class"))
      }
      this.innerDOM.appendChild(template.content.cloneNode(true))

      this.innerDOM.querySelector(".search .search__input").setAttribute("placeholder", this.getAttribute("data-placeholder-text"))


      this.cachedResults = {};
      this.input = this.innerDOM.querySelector('input[type="text"]');
      this.piiWarning = this.innerDOM.querySelector('.v5-pii-warning');
      this.recommendList = this.innerDOM.querySelector('.recommend-search-list');
      this.predictiveSearchResults = this.innerDOM.querySelector('[data-header-search]');
      this.isOpen = false;

      this.enableSearchCheckPii = window.pageInfo?.search_check_pii_enable === true;
      this.sensitiveSearchMessage = window.pageInfo?.search_pii_sensitive_info;
      this.piiValidator = window.JkyPiiValidator ? new window.JkyPiiValidator({ enabled: this.enableSearchCheckPii }) : null

      this.setupEventListeners();

      let shadow = this.attachShadow({ mode: 'open' })
      shadow.appendChild(this.innerDOM)

      this.renderRecommendList();

      const _self = this
      this.innerDOM.querySelector(".search-modal__close-button").addEventListener("click", function () {
        document.querySelector(".header-search__private").classList.remove('fade-in');
        document.querySelector(".header-search__private").classList.add('fade-out');
        document.querySelector(".header-search__private").querySelector('.modal-content').classList.remove('fade-in');
        setTimeout(function () {
          document.querySelector(".header-search__private").style.display = 'none';
          document.querySelector(".header-search__private").classList.remove('fade-out');
          // 恢复页面滚动
          resetContentWidth();
          jkyUtils?.enablePageScroll();
        }, 300);
        _self.close()
      })

      // 推荐搜索词点击事件 - 使用事件委托
      this.recommendList.addEventListener("click", function (e) {
        const item = e.target.closest('.predictive-search__item');
        if (!item) return;
        if (item.tagName.toLowerCase() === 'a') return;
        _self.input.value = item.textContent;

        // 检查搜索词是否包含敏感信息
        if (_self.isSensitiveSearchTerm(item.textContent)) {
          _self.showSensitiveSearchMessage();
          return;
        } else {
          _self.saveSearchHistory(item.textContent);
          const form = _self.innerDOM.querySelector('form.search');
          form.submit();
        }
      })

      this.storiesData = null;
      this.initStoriesCache();
    }

    initStoriesCache() {
      if (this.storiesPromise) return this.storiesPromise;
      const storiesUrl = window.pageInfo?.cr === 'US' ? '/pages/jackery-stories-all' : '/pages/jackery-stories'
      this.storiesPromise = fetch(storiesUrl)
        .then(res => {
          if (!res.ok) throw new Error(res.status);
          return res.text();
        })
        .then(html => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const links = doc.querySelectorAll('a.stories-item-card');
          this.storiesData = Array.from(links).map(a => {
            const titleEl = a.querySelector('.gallery-box-text');
            const imgEl = a.querySelector('img');
            const imgSrc = imgEl ? (imgEl.getAttribute('src') || imgEl.getAttribute('data-src')) : null;
            const tagEl = a.querySelector('.life-story-tag');
            const descEl = a.querySelector('.hover-overlay p');
            return titleEl ? { 
              title: titleEl.textContent.trim(), 
              url: a.getAttribute('href'), 
              img: imgSrc,
              tag: tagEl?.textContent.trim() || '',
              desc: descEl?.textContent.trim() || ''
            } : null;
          }).filter(Boolean);
        })
        .catch(e => {
          console.error('Error fetching stories:', e);
          this.storiesData = [];
        });
      return this.storiesPromise;
    }

    // 监听打开 - [hd-open] 变化即打开
    static get observedAttributes() {
      return ['hd-open'];
    }
    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'hd-open') {
        this.open()
      }
    }

    setupEventListeners() {
      const form = this.innerDOM.querySelector('form.search');
      form.addEventListener('submit', this.onFormSubmit.bind(this));

      this.input.addEventListener('input', debounce((event) => {
        this.onChange(event);
      }, 300).bind(this));
      this.input.addEventListener('focus', this.onFocus.bind(this));
      this.addEventListener('focusout', this.onFocusOut.bind(this));
      this.addEventListener('keyup', this.onKeyup.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
    }

    getQuery() {
      return this.input.value.trim();
    }

    isSensitiveSearchTerm(searchTerm) {
      if (!this.enableSearchCheckPii) return false;
      if (!this.piiValidator && window.JkyPiiValidator) {
        this.piiValidator = new window.JkyPiiValidator({ enabled: true });
      }
      if (!this.piiValidator) return false;
      this.piiValidator.enabled = this.enableSearchCheckPii === true;
      return this.piiValidator.isSensitiveSearchTerm(searchTerm);
    }

    showSensitiveSearchMessage() {
      this.piiWarning.innerHTML = this.sensitiveSearchMessage ? `<div style="padding:0.5rem 0;">${this.sensitiveSearchMessage?.trim() || ''}</div>` : '';
    }

    getRecommendData() {
      if (window.websiteV5RecommendSearch) return window.websiteV5RecommendSearch;
      const el = document.getElementById('v5-recommend-search-data');
      if (!el) return null;
      try {
        const data = JSON.parse(el.textContent || '{}');
        window.websiteV5RecommendSearch = data && typeof data === 'object' ? data : {};
      } catch (e) {
        window.websiteV5RecommendSearch = {};
      }
      return window.websiteV5RecommendSearch;
    }

    onChange() {
      const searchTerm = this.getQuery();

      // 检查搜索词是否包含敏感信息
      if (this.isSensitiveSearchTerm(searchTerm)) {
        this.showSensitiveSearchMessage();
        return;
      } else {
        this.piiWarning.innerHTML = '';
      }

      // 显示或隐藏推荐搜索词列表
      this.toggleRecommendList(searchTerm.length === 0);

      if (searchTerm.length === 0) {
        this.close(true);
        return;
      }

      this.getSearchResults(searchTerm);
    }

    onFormSubmit(event) {
      // if (!this.getQuery().length || this.innerDOM.querySelector('[aria-selected="true"] a')) event.preventDefault();
      const term = this.getQuery();
      if (term.length > 0 && this.isSensitiveSearchTerm(term)) {
        event.preventDefault();
        this.showSensitiveSearchMessage();
        return;
      } else {
        this.piiWarning.innerHTML = '';
      }
      if (term.length > 0) {
        this.saveSearchHistory(term);
      }
      if (this.innerDOM.querySelector('[aria-selected="true"] a')) event.preventDefault();
    }

    onFocus() {
      this.renderRecommendList();
      const searchTerm = this.getQuery();

      if (this.isSensitiveSearchTerm(searchTerm)) {
        this.showSensitiveSearchMessage();
        return;
      } else {
        this.piiWarning.innerHTML = '';
      }

      // 显示或隐藏推荐搜索词列表
      this.toggleRecommendList(searchTerm.length === 0);

      if (!searchTerm.length) return;

      if (this.getAttribute('results') === 'true') {
        this.open();
      } else {
        this.getSearchResults(searchTerm);
      }
    }

    onFocusOut() {
      setTimeout(() => {
        if (this.contains(document.activeElement)) return;

        // 移动端输入框失焦（如收起键盘）时，保留输入值与搜索结果
        if (window.innerWidth < 1024) {
          const term = this.getQuery();
          if (term.length > 0) return;
          this.close(false);
          return;
        }

        this.close();
      })
    }

    onKeyup(event) {
      if (!this.getQuery().length) this.close(true);
      event.preventDefault();

      switch (event.code) {
        case 'ArrowUp':
          this.switchOption('up')
          break;
        case 'ArrowDown':
          this.switchOption('down');
          break;
        case 'Enter':
          this.selectOption();
          break;
      }
    }

    onKeydown(event) {
      // Prevent the cursor from moving in the input when using the up and down arrow keys
      if (
        event.code === 'ArrowUp' ||
        event.code === 'ArrowDown'
      ) {
        event.preventDefault();
      }
    }

    switchOption(direction) {
      if (!this.getAttribute('open')) return;

      const moveUp = direction === 'up';
      const selectedElement = this.innerDOM.querySelector('[aria-selected="true"]');
      const allElements = this.innerDOM.querySelectorAll('li');
      let activeElement = this.innerDOM.querySelector('li');

      if (moveUp && !selectedElement) return;

      this.statusElement.textContent = '';

      if (!moveUp && selectedElement) {
        activeElement = selectedElement.nextElementSibling || allElements[0];
      } else if (moveUp) {
        activeElement = selectedElement.previousElementSibling || allElements[allElements.length - 1];
      }

      if (activeElement === selectedElement) return;

      activeElement.setAttribute('aria-selected', true);
      if (selectedElement) selectedElement.setAttribute('aria-selected', false);

      this.setLiveRegionText(activeElement.textContent);
      this.input.setAttribute('aria-activedescendant', activeElement.id);
    }

    selectOption() {
      const selectedProduct = this.innerDOM.querySelector('[aria-selected="true"] a, [aria-selected="true"] button');

      if (selectedProduct) selectedProduct.click();
    }

    getSearchResults(searchTerm) {
      if (!searchTerm) {
        this.close(false);
        return;
      }

      if (this.isSensitiveSearchTerm(searchTerm)) {
        this.showSensitiveSearchMessage();
        return;
      } else {
        this.piiWarning.innerHTML = '';
      }

      const queryKey = searchTerm.replace(" ", "-").toLowerCase();
      this.setLiveRegionLoadingState();

      if (this.cachedResults[queryKey]) {
        this.renderSearchResults(this.cachedResults[queryKey]);
        return;
      }

      const resourceTypes = encodeURIComponent(window.pageInfo.search_query || "product,page,article");
      const fetchPredictive = fetch(`${routes.predictive_search_url}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('resources[type]')}=${resourceTypes}&${encodeURIComponent('resources[limit]')}=10&${encodeURIComponent('resources[options][prefix]')}=last&section_id=predictive-search-v5`)
        .then((response) => {
          if (!response.ok) {
            var error = new Error(response.status);
            this.close(false);
            throw error;
          }
          return response.text();
        });
      const fetchSearchPageProducts = fetch(`${routes.search_url || '/search'}?q=${encodeURIComponent(searchTerm)}&${encodeURIComponent('options[prefix]')}=last&type=product&section_id=main-search-v5`)
        .then((response) => {
          if (!response.ok) return null;
          return response.text();
        })
        .catch(() => null);
      const storiesPromise = this.storiesPromise || Promise.resolve();

      Promise.all([fetchPredictive, storiesPromise, fetchSearchPageProducts])
        .then(([text, , searchProductsMarkup]) => {
          const doc = new DOMParser().parseFromString(text, 'text/html');
          const searchSection = doc.querySelector('#shopify-section-predictive-search-v5');
          if (searchSection) {
            const parseBool = (value, defaultValue = true) => {
              if (value === undefined || value === null) return defaultValue;
              if (typeof value === 'boolean') return value;
              if (typeof value === 'number') return value !== 0;
              if (typeof value === 'string') {
                const v = value.trim().toLowerCase();
                if (v === 'true' || v === '1') return true;
                if (v === 'false' || v === '0') return false;
              }
              return defaultValue;
            };
            const enableSorting = parseBool(window.pageInfo?.enable_sorting, true);

            const shopIds = ['55005249633', '79611232554', '60738666677', '9709262'] // Demo Uat Ca Us
            if (enableSorting && shopIds.includes(window.shopId)) {
              const productsContainer = searchSection.querySelector(
                'ul#v5-predictive-search-results-list[aria-labelledby="v5-predictive-search-products"]'
              );

              if (productsContainer) {
                const synced = this.syncPredictiveProducts(searchSection, searchProductsMarkup);
                if (!synced) {
                  this.sortProductList(productsContainer, searchTerm);
                }
              }

              const articlesContainer = searchSection.querySelector(
                'ul#v5-predictive-search-articles-list[aria-labelledby="v5-predictive-search-articles"]'
              );
              if (articlesContainer) {
                this.sortArticleList(articlesContainer, searchTerm);
              }
            }

            // Custom Stories Search
            if (this.storiesData && this.storiesData.length > 0) {
              const term = searchTerm.toLowerCase();
              const matchedStories = this.storiesData.filter(s => 
                s.title.toLowerCase().includes(term) || s.desc.toLowerCase().includes(term)
              );

              if (matchedStories.length > 0) {
                const STORY_SCENARIO_ORDER = ['home backup', 'off-grid living', 'camping', 'rv', 'boating', 'photography', 'aircraft', 'marine'];

                if (enableSorting) {
                  matchedStories.sort((a, b) => {
                      const tl = a.title.toLowerCase();
                      const dl = a.desc.toLowerCase();
                      const tg = a.tag.toLowerCase();
                      
                      const tl_b = b.title.toLowerCase();
                      const dl_b = b.desc.toLowerCase();
                      const tg_b = b.tag.toLowerCase();

                      const ml_a = (dl.includes(term) ? 0 : (tl.includes(term) ? 1 : 2));
                      const ml_b = (dl_b.includes(term) ? 0 : (tl_b.includes(term) ? 1 : 2));
                      
                      if (ml_a !== ml_b) return ml_a - ml_b;
                      
                      const getTagIdx = (t) => {
                          return STORY_SCENARIO_ORDER.reduce((min, sc, i) => t.includes(sc) ? Math.min(min, i) : min, STORY_SCENARIO_ORDER.length);
                      };
                      
                      const ti_a = getTagIdx(tg);
                      const ti_b = getTagIdx(tg_b);
                      
                      return ti_a - ti_b;
                  });
                }

                const resultsContainer = searchSection.querySelector('#v5-predictive-search-results') || searchSection;
                let storiesUl = resultsContainer.querySelector('#v5-predictive-search-stories-list');
                if (!storiesUl) {
                  const h2 = document.createElement('h2');
                  h2.id = "v5-predictive-search-stories";
                  h2.className = "v5-predictive-search__heading text-body caption-with-letter-spacing";
                  h2.textContent = window.websiteV5RecommendSearch?.stories_title || 'Stories';

                  storiesUl = document.createElement('ul');
                  storiesUl.id = "v5-predictive-search-stories-list";
                  storiesUl.className = "predictive-search__results-list list-unstyled";
                  storiesUl.setAttribute('role', 'listbox');
                  storiesUl.setAttribute('aria-labelledby', 'v5-predictive-search-stories');
                  const articlesList = resultsContainer.querySelector('ul#v5-predictive-search-articles-list[aria-labelledby="v5-predictive-search-articles"]');
                  if (articlesList && articlesList.parentNode) {
                    articlesList.parentNode.insertBefore(h2, articlesList.nextSibling);
                    articlesList.parentNode.insertBefore(storiesUl, h2.nextSibling);
                  } else {
                    resultsContainer.appendChild(h2);
                    resultsContainer.appendChild(storiesUl);
                  }
                }

                const existingUrls = Array.from(storiesUl.querySelectorAll('a')).map(a => a.getAttribute('href'));

                matchedStories.forEach((story) => {
                  if (existingUrls.includes(story.url)) return;

                  const li = document.createElement('li');
                  li.className = "predictive-search__list-item";
                  li.setAttribute('role', 'option');
                  li.innerHTML = `
                         <a href="${story.url}" class="predictive-search__item predictive-search__item--link link link--text" tabindex="-1">
                           ${story.img ? `<img class="predictive-search__image shrink-0" src="${story.img}" alt="${story.title}" width="50" />` : ``}
                           <div class="predictive-search__item-content predictive-search__item-content--centered">
                             <h3 class="predictive-search__item-heading h5">${story.title}</h3>
                           </div>
                         </a>
                       `;
                  storiesUl.appendChild(li);
                });
              }
            }

            this.capLists(searchSection);
            const resultsMarkup = searchSection.innerHTML;
            this.cachedResults[queryKey] = resultsMarkup;
            this.renderSearchResults(resultsMarkup);
          }
        })
        .catch((error) => {
          this.close(false);
          throw error;
        });
    }

    sortProductList(ul, term) {
      if (!ul) return;

      const normalizedTerm = term ? term.toLowerCase().trim() : '';
      const compactTerm = normalizedTerm.replace(/[-\s]/g, '');
      const termWords = normalizedTerm.split(/\s+/).filter(Boolean);
      const tailCompact = termWords.length > 1 ? termWords.slice(-2).join('').replace(/[-\s]/g, '') : '';
      const getFallbackMatchPriority = (titleText, handle) => {
        const compactTitle = titleText.replace(/[-\s]/g, '');
        const compactHandle = handle.replace(/[-\s]/g, '');
        if (compactTerm && (compactTitle.includes(compactTerm) || compactHandle.includes(compactTerm))) return 0;
        if (tailCompact && (compactTitle.includes(tailCompact) || compactHandle.includes(tailCompact))) return 1;
        if (normalizedTerm && (titleText.includes(normalizedTerm) || handle.includes(normalizedTerm))) return 2;
        return 3;
      };
      const getFallbackSortRank = (titleText, handle, available, isKitAttr) => {
        const isSolarGenerator = titleText.includes('solar generator') || titleText.includes('solar-generator');
        const isKit = isKitAttr === 'true' || isSolarGenerator;
        const isRefurbished = titleText.includes('refurbished') || handle.includes('refurbished');
        const isAddOn = titleText.includes('add-on') || titleText.includes('addon') || titleText.includes('add on') || handle.includes('addon') || handle.includes('add-on');
        const isSeries = titleText.includes('series') || handle.includes('series');
        const hasJackery = titleText.includes('jackery') || handle.includes('jackery');

        if (isKit) return 0;
        if (isRefurbished) return 5;
        if (isAddOn) return 6;
        if (isSeries) return 7;
        if (available) return hasJackery ? 1 : 2;
        return hasJackery ? 3 : 4;
      };

      const items = Array.from(ul.querySelectorAll('li')).map((el, idx) => {
        const titleText = (
          el.getAttribute('data-product-title')
          || el.querySelector('.predictive-search__item-heading')?.textContent
          || el.textContent
          || ''
        ).toLowerCase().trim();
        const handle = (el.getAttribute('data-product-handle') || '').toLowerCase();
        const isKitAttr = el.getAttribute('data-is-kit');
        const availableAttr = el.getAttribute('data-product-available');
        const sortRankAttr = parseInt(el.getAttribute('data-product-sort-rank') || '', 10);
        const matchPriorityAttr = parseInt(el.getAttribute('data-product-sort-match-priority') || '', 10);
        let available = true;
        if (availableAttr !== null) {
          available = availableAttr === 'true';
        } else {
          available = !(titleText.includes('soldout') || titleText.includes('sold out'));
        }

        return {
          el,
          index: idx,
          sortRank: Number.isNaN(sortRankAttr) ? getFallbackSortRank(titleText, handle, available, isKitAttr) : sortRankAttr,
          matchPriority: Number.isNaN(matchPriorityAttr) ? getFallbackMatchPriority(titleText, handle) : matchPriorityAttr
        };
      });

      items.sort((a, b) => {
        if (a.matchPriority !== b.matchPriority) return a.matchPriority - b.matchPriority;
        if (a.sortRank !== b.sortRank) return a.sortRank - b.sortRank;
        return a.index - b.index;
      });

      const fragment = document.createDocumentFragment();
      items.forEach(item => {
        fragment.appendChild(item.el);
      });

      ul.innerHTML = '';
      ul.appendChild(fragment);

      return ul;
    }

    parseSearchPageProducts(markup) {
      if (!markup) return [];
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const productDataEl = doc.querySelector('[data-product-results-json]');
      if (!productDataEl) return [];
      try {
        const products = JSON.parse(productDataEl.textContent || '[]');
        return Array.isArray(products) ? products : [];
      } catch (error) {
        return [];
      }
    }

    getSortedSearchPageProducts(products) {
      return [...products]
        .map((product, index) => ({ product, index }))
        .sort((a, b) => {
          const aMatch = a.product?.sort_match_priority ?? 3;
          const bMatch = b.product?.sort_match_priority ?? 3;
          if (aMatch !== bMatch) return aMatch - bMatch;
          const aRank = a.product?.sort_rank ?? 999;
          const bRank = b.product?.sort_rank ?? 999;
          if (aRank !== bRank) return aRank - bRank;
          return a.index - b.index;
        })
        .map(item => item.product);
    }

    escapeHtml(value) {
      return String(value ?? '')
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#39;');
    }

    syncPredictiveProducts(searchSection, searchProductsMarkup) {
      if (!searchSection || !searchProductsMarkup) return false;
      const sortedProducts = this.getSortedSearchPageProducts(this.parseSearchPageProducts(searchProductsMarkup)).slice(0, 3);
      if (sortedProducts.length === 0) return false;

      const productsContainer = searchSection.querySelector(
        'ul#v5-predictive-search-results-list[aria-labelledby="v5-predictive-search-products"]'
      );
      if (!productsContainer) return false;

      let useCentered = false;
      const existingItem = productsContainer.querySelector('li');
      if (existingItem) {
        useCentered = existingItem.querySelector('.predictive-search__item-content--centered') !== null;
      }

      productsContainer.innerHTML = sortedProducts.map((product, index) => `
        <li id="predictive-search-option-${index + 1}" class="predictive-search__list-item" role="option" aria-selected="false" data-product-id="${this.escapeHtml(product.id)}" data-product-title="${this.escapeHtml(product.title)}" data-product-handle="${this.escapeHtml(product.handle)}" data-product-available="${product.available === true}" data-is-kit="${product.is_kit === true}" data-product-sort-rank="${this.escapeHtml(product.sort_rank)}" data-product-sort-match-priority="${this.escapeHtml(product.sort_match_priority)}">
          <a href="${this.escapeHtml(product.url || '#')}" class="predictive-search__item predictive-search__item--link link link--text" tabindex="-1">
            ${product.image_url ? `<img class="predictive-search__image flex-shrink-0" src="${this.escapeHtml(product.image_url)}" alt="${this.escapeHtml(product.image_alt || product.title || '')}" width="50" height="50">` : ``}
            <div class="predictive-search__item-content${useCentered ? ' predictive-search__item-content--centered' : ''}">
              <h3 class="predictive-search__item-heading h5">${this.escapeHtml(product.title || '')}</h3>
            </div>
          </a>
        </li>
      `).join('');

      if (!searchSection.querySelector('h2#v5-predictive-search-products')) {
        const headingText = productsContainer.getAttribute('data-products-heading') || 'Products';
        const heading = document.createElement('h2');
        heading.id = 'v5-predictive-search-products';
        heading.className = 'v5-predictive-search__heading text-body caption-with-letter-spacing';
        heading.textContent = headingText;
        productsContainer.parentNode.insertBefore(heading, productsContainer);
      }

      return true;
    }

    sortArticleList(ul, term) {
      if (!ul) return;
      
      const ARTICLE_TAG_ORDER = ['buying advice', 'news', 'emergency', 'lifestyle', 'knowledge'];
      term = term ? term.toLowerCase().trim() : '';

      const items = Array.from(ul.querySelectorAll('li')).map((el, idx) => {
        const title = (el.textContent || '').toLowerCase();
        // Note: Cannot easily access tags in predictive search results as they are not usually rendered in text.
        // Sorting will rely primarily on title match if tags are missing.
        const matchLevel = term && title.includes(term) ? 0 : 2;
        const tagIdx = ARTICLE_TAG_ORDER.length;
        const updated = 0;
        
        return { el, index: idx, matchLevel, tagIdx, updated };
      });

      items.sort((a, b) => {
        if (a.matchLevel !== b.matchLevel) return a.matchLevel - b.matchLevel;
        if (a.tagIdx !== b.tagIdx) return a.tagIdx - b.tagIdx;
        if (a.updated !== b.updated) return b.updated - a.updated;
        return a.index - b.index;
      });

      const fragment = document.createDocumentFragment();
      items.forEach(item => fragment.appendChild(item.el));
      ul.innerHTML = '';
      ul.appendChild(fragment);
    }

    capLists(container) {
      const cap = (selector, max) => {
        const ul = container.querySelector(selector);
        if (!ul) return;
        const items = Array.from(ul.querySelectorAll('li')).filter(li => !li.querySelector('.predictive-search__item--term'));
        items.slice(max).forEach(li => li.remove());
      };
      cap('#v5-predictive-search-results-list', 3);
      cap('#v5-predictive-search-pages-list', 2);
      cap('#v5-predictive-search-articles-list', 2);
      cap('#v5-predictive-search-stories-list', 2);
    }

    setLiveRegionLoadingState() {
      this.statusElement = this.statusElement || this.innerDOM.querySelector('.header-search-status');
      this.loadingText = this.loadingText || this.getAttribute('data-loading-text');

      this.setLiveRegionText(this.loadingText);
      this.setAttribute('loading', true);
    }

    setLiveRegionText(statusText) {
      this.statusElement.setAttribute('aria-hidden', 'false');
      this.statusElement.textContent = statusText;

      setTimeout(() => {
        this.statusElement.setAttribute('aria-hidden', 'true');
      }, 1000);
    }

    renderSearchResults(resultsMarkup) {
      this.predictiveSearchResults.innerHTML = resultsMarkup;

      const searchTerm = this.getQuery();
      if (searchTerm && searchTerm.length > 0) {
        this.highlightSearchTerm(searchTerm);
      }

      this.setAttribute('results', true);

      this.setLiveRegionResults();
      this.open();
    }

    // 高亮搜索词
    highlightSearchTerm(term) {
      if (!term) return;
      const regex = new RegExp(`(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`, 'gi');
      const targets = this.predictiveSearchResults.querySelectorAll('.predictive-search__item-heading');
      targets.forEach(el => {
        el.innerHTML = el.innerHTML.replace(regex, '<span style="font-weight:600;">$1</span>');
      });
    }

    setLiveRegionResults() {
      this.innerDOM.removeAttribute('loading');
      this.setLiveRegionText(this.innerDOM.querySelector('[data-predictive-search-live-region-count-value]').textContent);
    }

    getResultsMaxHeight() {
      // this.resultsMaxHeight = window.innerHeight - document.getElementById('shopify-section-header').getBoundingClientRect().bottom;
      this.resultsMaxHeight = window.innerHeight * 0.7
      return this.resultsMaxHeight;
    }

    open() {
      // this.predictiveSearchResults.style.maxHeight = this.resultsMaxHeight || `${this.getResultsMaxHeight()}px`;
      this.innerDOM.setAttribute('open', true);
      this.input.setAttribute('aria-expanded', true);
      this.isOpen = true;
      setTimeout(() => {
        this.input.focus()
      }, 10);
    }

    close(clearSearchTerm = true) {
      if (clearSearchTerm) {
        this.input.value = '';
        this.removeAttribute('results');
      }

      const selected = this.innerDOM.querySelector('[aria-selected="true"]');

      if (selected) selected.setAttribute('aria-selected', false);

      this.input.setAttribute('aria-activedescendant', '');
      this.innerDOM.removeAttribute('open');
      this.input.setAttribute('aria-expanded', false);
      this.resultsMaxHeight = false
      this.predictiveSearchResults.removeAttribute('style');

      this.isOpen = false;
      this.innerDOM.removeAttribute('loading');
    }

    /**
     * 获取搜索历史
     */
    getSearchHistory() {
      try {
        const history = localStorage.getItem('shopify_search_history');
        return history ? JSON.parse(history) : [];
      } catch (e) {
        return [];
      }
    }

    /**
     * 保存搜索历史
     */
    saveSearchHistory(term) {
      if (!term || !term.trim()) return;
      term = term.trim();
      let history = this.getSearchHistory();

      // 去重
      history = history.filter(item => item !== term);

      // 插入头部
      history.unshift(term);

      // 保留前5条
      if (history.length > 5) {
        history = history.slice(0, 5);
      }

      localStorage.setItem('shopify_search_history', JSON.stringify(history));
    }

    /**
     * 渲染推荐关键词
     */
    renderRecommendList() {
      const data = this.getRecommendData();
      let fullHtml = '';

      if (!this._staticRecommendHtmlBuilt && data) {
        this._staticRecommendHtmlBuilt = true;
        this._staticRecommendHtml = '';

        if (data?.list && Array.isArray(data.list)) {
          data.list.forEach((group) => {
            if (!group.list || group.list.length === 0) return;

            let listHtml = '';
            group.list.forEach(item => {
              let raw = item.title || '';
              let href = '';
              let mainText = '';
              let corner = '';

              const anchorMatch = raw && raw.match(/<a\s[^>]*href=["']([^"']+)["'][^>]*>([\s\S]*?)<\/a>/i);
              if (anchorMatch) {
                href = anchorMatch[1];
              }

              const tmp = document.createElement('div');
              tmp.innerHTML = raw;
              let text = (tmp.textContent || '').trim();

              if (text && text.includes(':::')) {
                const parts = text.split(':::');
                mainText = (parts[0] || '').trim();
                corner = (parts[1] || '').trim();
              } else {
                mainText = text;
              }

              if (!mainText) return;

              if (href) {
                listHtml += `
                  <li class="predictive-search__list-item">
                    <a class="predictive-search__item" href="${href}">${mainText}</a>
                    ${corner ? `<span class="predictive-search__item-corner">${corner}</span>` : ''}
                  </li>
                `;
              } else {
                listHtml += `
                  <li class="predictive-search__list-item">
                    <span class="predictive-search__item" data-term="${mainText}">${mainText}</span>
                    ${corner ? `<span class="predictive-search__item-corner">${corner}</span>` : ''}
                  </li>
                `;
              }
            })

            this._staticRecommendHtml += `
              <h2 class="v5-predictive-search__heading">${group.title}</h2>
              <ul class="predictive-search__results-list">${listHtml}</ul>
            `;
          });
        }
      }

      fullHtml += this._staticRecommendHtml || '';

      // 渲染搜索历史
      const history = this.getSearchHistory();
      if (history.length > 0) {
        let historyHtml = '';
        history.forEach(term => {
          historyHtml += `
            <li class="predictive-search__list-item">
              <span class="predictive-search__item predictive-history-search__item" data-term="${term}">${term}</span>
            </li>
          `;
        });

        fullHtml += `
          <h2 class="v5-predictive-search__heading">${data?.search_history_title || ''}</h2>
          <ul class="predictive-search__results-list">${historyHtml}</ul>
        `;
      }

      if (this._lastRecommendHtml === fullHtml) return;
      this._lastRecommendHtml = fullHtml;
      this.recommendList.innerHTML = fullHtml;
    }

    /**
     * 显示或隐藏推荐词列表
     * @param flag true/false
     */
    toggleRecommendList(flag) {
      const data = this.getRecommendData();
      if (!data) {
        if (!flag) this.recommendList.style.display = 'none';
        return;
      }
      if (flag) {
        this.recommendList.style.display = 'block';
      } else {
        this.recommendList.style.display = 'none';
      }
    }
  }

  customElements.define('v5-header-search', V5HeaderSearch);
}
